import { Container, Divider } from '@chakra-ui/react';
import CustomStepper from 'components/ui/custom-stepper/CustomStepper';
import StepperProvider, { useStepperContext } from 'components/ui/custom-stepper/CustomStepperContext';
import HeaderBarInternal from 'components/ui/HeaderBarInternal';
import { FormCreateListData, FormCreateListMembers } from '../components/forms';
import { CreateListDataProvider } from '../contexts/CreateListDataContext';

export default function PageCreateList() {
  return (
    <StepperProvider 
      steps={['Dados da Lista', 'Membros']}
    >
      <CreateListDataProvider>
        <HeaderBarInternal
          title="Nova lista"
          backTo="/listas-de-disparo"
        >
          <CustomStepper />
        </HeaderBarInternal>
        
        <Divider />

        <Container 
          variant="internal"
          flexDirection="column"
          minH="700px"
        >
          <CurrentStep />
        </Container>
      </CreateListDataProvider>
    </StepperProvider>
  )
}

function CurrentStep() {
  const { activeStep } = useStepperContext();
  
  if (activeStep === 0)
    return <FormCreateListData />;
  
  if (activeStep === 1)
    return <FormCreateListMembers />;
  
  return null;
}